import { OnEventDispatcher } from './on-event-dispatcher'; 

export class Reloader extends OnEventDispatcher {
    call_in_progress:boolean = false;
    constructor() {
        super();
        this.recall();
    }
    recall() {
        if(this.call_in_progress) return;
        this.call_in_progress = true;
        let call_returned:boolean = false;
        setTimeout(() => {
            $.ajax({
                method: "GET",
                url: "/reloader",
                cache: false,
                complete: (data:any) => {
                    if(call_returned) return;
                    call_returned = true;
                    if(data.responseText=="1") this.dispatch("reload");
                    setTimeout(() => {
                        this.call_in_progress = false;
                        this.recall();
                    }, 500);
                },
                error: (jqXHR:any, textStatus:string, errorThrown:any) => {
                    if(call_returned) return;
                    call_returned = true;
                    console.error(errorThrown);
                    setTimeout(() => {
                        this.call_in_progress = false;
                        this.recall();
                    }, 5000);
                }
            });
        }, 10);
    }
}